import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-coverage",
  "use": "gw-coverage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-coverage\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M12.37 18V5.9L6.78 8.22c.32 4.53 2.54 7.91 5.58 9.77Zm8.22-12.74-7.51-3.13-.01-.01c-.47-.2-.99-.2-1.45 0L4.11 5.24c-.7.28-1.16.97-1.16 1.73 0 7.75 4.47 13.11 8.65 14.85.46.19.98.19 1.44 0 3.34-1.4 8.65-6.22 8.65-14.86 0-.76-.46-1.45-1.16-1.74v-.01Zm-8.23 14.85c-3.81-1.59-7.51-6.52-7.51-13.13l7.5-3.13 7.5 3.12c0 6.78-3.85 11.6-7.51 13.12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol